import { Redis } from "@upstash/redis";

export type ConnectionType = {
  redis?: Redis,
  pipeline?: any //should be Pipeline, but how?
}

export default class ActiveRedis {

  static redis() {
    return new Redis({
      url: process.env.KS_REDIS_URL,
      token: process.env.KS_REDIS_TOKEN,
    });
  }
}

export interface ISortable {
  order: string
}

export const DEFAULT_INCREMENT = 10;